import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id BFCE431D-2F97-4023-A690-F34199CA79F8
 * name television-play
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television-play.svg
 * tags
 * - Device / Tech 
 */
export const TelevisionPlayIcon = createSvgIcon(<><path d="M21,3H3C1.89,3 1,3.89 1,5V17A2,2 0 0,0 3,19H8V21H16V19H21A2,2 0 0,0 23,17V5C23,3.89 22.1,3 21,3M21,17H3V5H21M16,11L9,15V7" /></>, 'TelevisionPlayIcon');
export default TelevisionPlayIcon